// @flow
import React, {useContext} from "react";
import * as PropTypes from "prop-types";
import LIUtils, {SAMPLE_TYPE_BLOCK} from "../GUI_COMMON/SUPPORT/LIUtils";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import GuiUtils from "../GUI_COMMON/SUPPORT/GuiUtils";

const SampleCard = ({sampleItem, displayDate, needsAttention, showPosition, onClick, showStatus=true}) => {
    
    const [globalState] = useContext(StoreContext);
    
    function showCaseAsSubTitle() {
        
        return(  
            <>
                <div><strong>Case#:</strong> {sampleItem.caseNumber??"-"}</div>
                <div><strong>Sample#:</strong> {sampleItem.sampleNumber??"-"}</div>
            </>
        );
    }
    
    function handleOnClick() {
        if(onClick) {
            onClick();
        }
    }
    
    function sampleIsOut(){
        return(!sampleItem.magBarcode ||sampleItem.magBarcode === "");
    }

    function showSampleIsInOutOrPendingOrDup() {
        const spanInfo = ArchiverGuiUtils.ShowSampleIsInOutOrPendingOrPicked(sampleItem);
        return (
                <div>
                    {spanInfo}
                </div>
            );
    }
    
    function showManuallyEdited() {
        const manuallyEdited=ArchiverGuiUtils.ShowSampleIsManuallyEdited(sampleItem);
        if(manuallyEdited) {
            return (
                <div >
                    {manuallyEdited}
                </div>);
        }
    }
    
    function showPositionIfRequired() {
        if (showPosition) {
            
            if(sampleIsOut()) {
                return null;
            }
                
            const sectionAsName = LIUtils.convertMagSectionIndexToAlpha(sampleItem.magSection);
            let sectionFgColor;
            switch(sectionAsName) {
                case "A":
                    sectionFgColor = "li-position-marker-section-a";
                    break;
                case "B":
                    sectionFgColor = "li-position-marker-section-b";
                    break;
                case "C":
                    sectionFgColor = "li-position-marker-section-c";
                    break;
                case "D":
                    sectionFgColor = "li-position-marker-section-d";
                    break;
                default:
                    sectionFgColor = "";
            }
            
            return  <div>
                        <div className={"d-inline badge badge-white li-font-tiny "+sectionFgColor}>{sectionAsName}#{sampleItem.positionAbsolute}</div>
                    </div>
        }
        return null;
    }
    
    function showDateIfRequired() {
        if(LIUtils.existsAndNotEmpty(displayDate)) {
            const d:Date = LIUtils.dateFromJsonUtcDateStr(displayDate);
            return  <>
                <div className={"d-inline li-font-tiny li-bottom-right"}>added {d.toLocaleString()}</div>
            </>
        }
    }
    
    function getBadgeColorGivenSampleType(sampleType) {
        if(sampleType===SAMPLE_TYPE_BLOCK) {
            return(
                "li-bg-blue li-fg-white"
            );
        }
        return(
            "li-bg-primary li-fg-white"
        );
    }
    
    function showColorBar(colorClass) {
        //return <div className={colorClass+" li-sample-color-bar"}></div>;
    }
    
    function dumpSampleImageOrIcon(imageData, sType) {
        if(imageData) {
            return LIUtils.getImgFromImageData(imageData, null, 100);
        }
        const sTypeImage = GuiUtils.GetSampleTypeImageGivenId(sType, globalState.sampleTypes.items);
        if(sTypeImage) {
            return LIUtils.getImgFromImageData(sTypeImage, "", 50, sType);
        }
        return null;
    }
    
    let colorClass="";

    if(!sampleItem) {// just a spacer
        return <div className="card li-sample-card clear"/>;
    }

    // this follows here for a reason!
    if(needsAttention) {
        if(sampleItem.isDuplicate) { // overrides standard needs attention
            colorClass = " li-bg-duplicate li-sample-card-border-duplicate";
        }
        else if(!LIUtils.existsAndNotEmpty(sampleItem.barcode)) { // no barcode 
            // (more informative than no profile) -- added by pott 250126
            colorClass = " li-sample-card-border-missing-barcode";
        }
        else if(!LIUtils.existsAndNotEmpty(sampleItem.profileId)) {
            // changed by pott - 240508 - // barcode present, but missing profile id - special colour
            // no longer require a barcode to be present here - profiles that are missing are bad.
            colorClass = " li-bg-missing-profile li-sample-card-border-missing-profile"; //li-flash" // removed 230613 -pott
        }
        else { // standard needs attention
            colorClass = " li-bg-danger li-sample-card-border-danger";
        }
    }
    
    
    return(
        <div className={"card li-sample-card "+colorClass} style={{margin:"10px"}} onClick={handleOnClick}>
            <div className="card-body p-0">
                <div className="row justify-content-between p-0 m-0">
                    <div className="d-flex">
                        {showColorBar(colorClass)}
                        <div className="p-0 medium mr-1 align-self-center li-z-plus-1">
                            {dumpSampleImageOrIcon(sampleItem.imageData,sampleItem.sampleType)}
                        </div>
                        <div>
                            <div className="card-title font-weight-bold w-100 text-truncate" data-toggle="tooltip" data-placement="auto" title={sampleItem.barcode}>
                                Barcode#: {LIUtils.SanitizeBarcodeToLength(sampleItem?.barcode,18)}</div>
                            <h6 className="card-subtitle">{showCaseAsSubTitle()}</h6>
                        </div>
                    </div>
                    <div className="text-right">
                        <div className={"text-center rounded px-1 "+getBadgeColorGivenSampleType(sampleItem.sampleType)}>
                            {GuiUtils.GetSampleTypeNameGivenId(sampleItem.sampleType, globalState.sampleTypes.items)}
                        </div>
                        {showStatus && 
                            <div className="row p-0 m-0 justify-content-end">
                                {showManuallyEdited()}
                                {showSampleIsInOutOrPendingOrDup()}
                            </div>
                        }
                        {showPositionIfRequired()}
                        {showDateIfRequired()}
                    </div>
                </div>
            </div>
        </div>                                          
    );
}
            
SampleCard.propTypes = {
    showPosition: PropTypes.bool,
    needsAttention: PropTypes.bool,
    sampleItem: PropTypes.object,
    onClick: PropTypes.func,
    showStatus: PropTypes.bool,
    displayDate: PropTypes.string,
    
}

export default SampleCard;